import Image from "next/image";
import Text from "@components/atoms/Text";
import { NoResultsStateProps } from "@interfaces/search-component.types";
import assetLoader from "@utils/internalImageLoder";
import styles from "../../organisms/SearchComponent/SearchComponent.module.scss";

export const NoResultsState = ({
  activeTab,
  searchQuery,
  variant,
}: NoResultsStateProps) => {
  return (
    <div className={styles.noResultsContainer}>
      <div className={styles.noResultsContent}>
        <Image
          src={`${assetLoader()}/icons/search.svg`}
          alt="No results"
          width={48}
          height={48}
          className={styles.noResultsIcon}
          loading="lazy"
        />
        <Text className={styles.noResultsTitle}>
          No {activeTab === "cars" ? "cars" : "articles"} found
        </Text>
        <Text className={styles.noResultsMessage}>
          We couldn&apos;t find any {activeTab === "cars" ? "cars" : "articles"}{" "}
          matching {searchQuery}. Try searching with different keywords.
        </Text>
      </div>
    </div>
  );
};

export default NoResultsState;
